import { MerchCardLayoutUI } from '../../../../components/MerchCardLayoutUI';
import { CustomerPlatformMerchCardSubheading } from '../../../../components/merch-card/headings-display/CustomerPlatformMerchCardSubheading';
import DetailedTermSelector from '../../../../components/merch-card/terms-display/DetailedTermSelector';
import { STARTER_CUSTOMER_PLATFORM_UPSELL_MERCH_CARD } from '../../../../constants/tracking/TrackingSources';
import { createUpsellMerchCardTrackingData } from '../../../../utils/trackingData';
import { PurchaseMotionContainer } from '../../../PurchaseMotionContainer';
import { IncludedHubSpotCreditsContainer } from '../../credits-display/IncludedHubSpotCreditsContainer';
import { PriorityFeaturesByProductApiName } from '../../features-display/PriorityFeaturesByProductApiName';
import { MerchCardTitleContainer } from '../../headings-display/MerchCardTitleContainer';
import { MerchCardPrice } from '../../price-display/MerchCardPrice';
import { SubtextDisplayContainer } from '../../subtext-display/SubtextDisplayContainer';

/*
 * This card is rendered on the public starter tab on hub pages
 * and for free TB portals in app.
 * Therefore there is no pre-seats version of this card.
 */
import { jsx as _jsx } from "react/jsx-runtime";
const UPSELL_PRODUCT_LEVEL = 'STARTER';

/*
 * Because the upsell card is only shown for free portals & public, and is STARTER,
 * we will always want to show the price per month per seat like we do for all
 * STARTER products on free portals & public
 */
const SHOW_PRICE_PER_MONTH_PER_SEAT = true;
export const UpsellCustomerPlatformMerchCard = ({
  productApiName,
  columnStart,
  Badge,
  Title,
  hubPageStarterApiName,
  lowerTierMessage,
  screen
}) => {
  const Features = /*#__PURE__*/_jsx(PriorityFeaturesByProductApiName, {
    productApiName: hubPageStarterApiName,
    lowerTierMessage: lowerTierMessage
  });
  return /*#__PURE__*/_jsx(MerchCardLayoutUI, {
    "data-test-id": `${productApiName}-merch-card`,
    "data-selenium-id": `${productApiName}-merch-card`,
    columnStart: columnStart,
    Badge: Badge,
    Title: /*#__PURE__*/_jsx(MerchCardTitleContainer, {
      Title: Title
    }),
    Subheading: /*#__PURE__*/_jsx(CustomerPlatformMerchCardSubheading, {
      productLevel: UPSELL_PRODUCT_LEVEL
    }),
    Pricing: /*#__PURE__*/_jsx(MerchCardPrice, {
      productApiName: productApiName,
      showPerMonthPerSeat: SHOW_PRICE_PER_MONTH_PER_SEAT
    }),
    Term: /*#__PURE__*/_jsx(DetailedTermSelector, {
      apiName: productApiName,
      trackingSource: STARTER_CUSTOMER_PLATFORM_UPSELL_MERCH_CARD
    }),
    Credits: /*#__PURE__*/_jsx(IncludedHubSpotCreditsContainer, {
      productApiName: productApiName,
      trackingSource: STARTER_CUSTOMER_PLATFORM_UPSELL_MERCH_CARD
    }),
    Subtext: /*#__PURE__*/_jsx(SubtextDisplayContainer, {
      productApiName: hubPageStarterApiName
    }),
    CTAs: /*#__PURE__*/_jsx(PurchaseMotionContainer, {
      productApiName: productApiName,
      location: "MERCH_CARD",
      trackingData: createUpsellMerchCardTrackingData(productApiName, screen)
    }),
    Features: Features
  });
};